import { createContext } from "react";
import { SiteInfoAppletData } from "./Body.jsx";

export default createContext<{
  primaryColor: string;
  backgroundImageUrl: string;
  applets: SiteInfoAppletData[];
  hasCrm: boolean;
  hasNotify: boolean;
}>({
  primaryColor: "#000",
  backgroundImageUrl: "",
  applets: [],
  hasCrm: false,
  hasNotify: false,
});
